var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('p',{staticClass:"tips1"},[_vm._v("404")])]),_c('div',[_c('p',{staticClass:"tips2"},[_vm._v("你访问的页面丢失了！")])])])}]

export { render, staticRenderFns }